import { http, HttpResponse } from 'msw';

import { ONLINE_ENDPOINTS } from '@/config/api';
import { env } from '@/config/env';
import { axios } from '@/lib/axios';
import { networkDelay } from '@/test/mocks/utils';

import type { StartLogbookRequest, StartLogbookResponse } from '../types';

// API function
export const startLogbook = (
  attemptId: string
): Promise<StartLogbookResponse> => {
  return axios.post(
    ONLINE_ENDPOINTS.USER.LOGBOOKS_START as string,
    {
      attempt_id: attemptId,
    } as StartLogbookRequest
  );
};

// Mock handler
export const startLogbookMockHandler = http.post(
  `${env.API_URL}${ONLINE_ENDPOINTS.USER.LOGBOOKS_START}`,
  async ({ request }): Promise<HttpResponse<StartLogbookResponse>> => {
    await networkDelay();

    const body = (await request.json()) as StartLogbookRequest;

    const mockResponse: StartLogbookResponse = {
      status: 'Success',
      message: 'Logbook marked as started',
      attempt_id: body.attempt_id,
      attempt_status: 'IN_PROGRESS',
    };

    return HttpResponse.json(mockResponse);
  }
);
